import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import { useGameStore } from './stores/gameStore'
import { SocketProvider } from './context/SocketContext'
import { initGA, trackPageView } from './utils/analytics'

// Components
import HomePage from './pages/HomePage'
import LobbyPage from './pages/LobbyPage'
import GamePage from './pages/GamePage'
import FallenPage from './pages/FallenPage'
import ChatPage from './pages/ChatPage'
import AnalyticsPage from './pages/AnalyticsPage'
import AboutPage from './pages/AboutPage'
import BackgroundEffects from './components/BackgroundEffects'
import LoadingScreen from './components/LoadingScreen'

// Component to track page views
function PageTracker() {
  const location = useLocation()

  useEffect(() => {
    // Track page view on route change
    trackPageView(document.title, window.location.href)
  }, [location])

  return null
}

function App() {
  const { isLoading } = useGameStore()

  useEffect(() => {
    // Initialize Google Analytics on app start
    initGA()
  }, [])

  return (
    <SocketProvider>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <PageTracker />
        <div className="min-h-screen bg-purgatory-dark text-purgatory-light relative overflow-hidden">
          {/* Background effects */}
          <BackgroundEffects />
          
          
          {/* Main content */}
          <div className="relative z-10">
            {isLoading && <LoadingScreen />}
            
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/lobby" element={<LobbyPage />} />
              <Route path="/game" element={<GamePage />} />
              <Route path="/fallen" element={<FallenPage />} />
              <Route path="/chat/:chatId" element={<ChatPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/about" element={<AboutPage />} />
            </Routes>
          </div>
        </div>
      </Router>
    </SocketProvider>
  )
}

export default App
